import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { addUser, updateUser } from '../../services/UserService';
import { toast } from 'react-toastify';
import { getCountryList, validatePassword, getAllCountryData, getAllStatesData, getAllCitiesData } from '../../services/CommonService';
import Select from 'react-select';
import { addMultipleCustomerAdminPermission } from '../../services/UserService';
import { CUSTOMER_ADMIN_PERMISSIONS } from '../../utility/Values';
import Loader from '../../utility/Loader';

export default function CreateAdmin() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({ user: { first_name: "" } });
    const [user, setUser] = useState({ first_name: "", middle_name: "", last_name: "", email: "", password: "", status: "ACTIVE", role: "ACCOUNT_OWNER", state: "", city: "", country: "USA", addr_line1: "", addr_line2: "", zip_code: "", phone_no: "" });
    const [countriesList, setCountriesList] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [countryCode, setCountryCode] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [edit, setEdit] = useState(false);
    useEffect(() => {
        const userDetails = getUserDetails();
        if (userDetails.token === undefined) {
            navigate('/login');
        } else {
            setUserDetails(userDetails);
            let adminUser = sessionStorage.getItem('adminEdit') !== undefined ? JSON.parse(sessionStorage.getItem('adminEdit')) : {};

            if (adminUser !== null && adminUser !== undefined && adminUser.email !== undefined) {
                setUser(adminUser);
                setEdit(true);
                sessionStorage.removeItem('adminEdit');
            } else {
                adminUser = {}
            }
            getCountries(adminUser);
        }
    }, []);

    const getCountries = async (adminUser) => {
        const userDetails = getUserDetails();
        if (userDetails.token !== undefined) {
            setLoading(true);
            const response = await getAllCountryData(userDetails.token);
            const countryList = response.data;
            setCountriesList(countryList);
            let cntry = [];
            let cntryCode = {};
            for (let i = 0; i < countryList.length; i++) {
                cntry.push({ label: countryList[i].country, value: countryList[i].country });

                cntryCode[countryList[i].country] = countryList[i].phone_cd
            }
            setCountries(cntry);
            setCountryCode(cntryCode);
            await changeCountryValue("country", user.country, countryList);
            if (adminUser.state !== undefined && adminUser.state !== '' && adminUser.state !== null) {
                await changeCountryValue("state", adminUser.state, countryList);
            }
            setLoading(false);
        } else {
            toast.info("Please login again");
            navigate('/login');
        }
    };

    const handleCountryValueChange = async (name, value) => {

        if (name === 'country') {
            setUser({
                ...user,
                ["state"]: undefined,
                [name]: value,
                ["city"]: undefined
            });
        } else if (name === 'state') {
            setUser({
                ...user,
                [name]: value,
                ["city"]: undefined
            });

        } else {
            setUser({
                ...user,
                [name]: value
            });
        }
        await changeCountryValue(name, value, countriesList);
    };

    const changeCountryValue = async (name, value, countryList) => {
        const userDetails = getUserDetails();
        if (name === 'country') {
            let values = [];
            const st = await getAllStatesData(userDetails.token, value);

            for (let i = 0; i < st.data.length; i++) {
                values.push({ label: st.data[i].state, value: st.data[i].state });
            }
            setStates(values);
        }
        if (name === 'state') {
            let values = [];
            const st = await getAllCitiesData(userDetails.token, value);
            for (let i = 0; i < st.data.length; i++) {
                values.push({ label: st.data[i].city, value: st.data[i].city });
            }
            setCities(values);
        }
    };

    const handleValueChange = (e) => {
        const { name, value } = e.target;
        setUser({
            ...user,
            [name]: value,
        });
    };

    const validateUser = (user) => {
        if(user.email === undefined || user.email === null || user.email === ''){
            toast.error("Email is required");
            return false;
        }
        if(user.password === undefined || user.password === null || user.password === ''){
            toast.error("Password is required");
            return false;
        }
        if (!validatePassword(user.password)) {
            toast.error("Password is not Valid. Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a numeral, and a special character.");
        }
        if(user.first_name === undefined || user.first_name === null || user.first_name === ''){
            toast.error("First name is required");
            return false;
        }
        if(user.country === undefined || user.country === null || user.country === ''){
            toast.error("Country is required");
            return false;
        }
        if(user.state === undefined || user.state === null || user.state === ''){
            toast.error("State is required");
            return false;
        }
        if(user.city === undefined || user.city === null || user.city === ''){
            toast.error("City is required");
            return false;
        }
        if(user.addr_line1 === undefined || user.addr_line1 === null || user.addr_line1 === ''){
            toast.error("Address line 1 is required");
            return false;
        }
        if(user.zip_code === undefined || user.zip_code === null || user.zip_code === ''){
            toast.error("Zip code is required");
            return false;
        }
        if(user.phone_no !== '' && user.phone_no !== undefined && user.phone_no !== null && (user.phone_no.length > 10 || user.phone_no.length < 7)){
            toast.warn("Phone number length should be between 7 and 10 digits!");
            return false;
        }
        if(user.zip_code.length > 5){
            toast.warn("Zip Code length is greater than 5 digits!");
            return false;
        }
        if(user.zip_code.length < 4){
            toast.warn("Zip Code length should be at least 4 digits!");
            return false;
        }
        return true;
    };



    const addAdmin = async () => {
        const userDetails = getUserDetails();
        const isValid = validateUser(user);
        if (isValid) {
            if (userDetails.token) {
                setLoading(true);
                let resp = await addUser(userDetails.token, user);
                setLoading(false);
                if (resp.error === false) {
                    await addAdminPermissions(resp.id, userDetails.user.customer_id);
                    toast.success("User with role Admin is created!");
                } else {
                    toast.error(resp.data);
                }
            } else {
                toast.info("Please login again");
                navigate('/login');
            }
        }

    };

    const updateAdmin = async () => {
        const userDetails = getUserDetails();
        const isValid = validateUser(user);
        if (isValid) {
            if (userDetails.token) {
                setLoading(true);
                let resp = await updateUser(userDetails.token, user);
                setLoading(false);
                if (resp.error === false) {
                    toast.success("Changes updated successfully!");
                } else {
                    toast.error(resp.data);
                }
            } else {
                toast.info("Please login again");
                navigate('/login');
            }
        }

    };

    const addAdminPermissions = async (user_id, customer_id) => {
        let data = { user_id: user_id, customer_id: customer_id, permission_code: CUSTOMER_ADMIN_PERMISSIONS };
        let resp = await addMultipleCustomerAdminPermission(userDetails.token, data);
        if (resp.error === false) {
        } else {
            toast.error("Error while adding permissions");
        }
    };

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className='lg:py-10 lg:px-12 py-10 px-6'>
                    <h3 className='text-2xl text-secondary text-center inter-700 mb-6 md:mb-4 lg:mb-3 lg:hidden'>Add New Learner</h3>
                    <div className='back-btn flex justify-start mb-5 md:mb-8'>
                        <a onClick={() => navigate('/admin/manageadmin')} className='cursor-pointer w-auto bg-tertiary hover:bg-black flex items-center justify-center px-6 h-7 2xl:h-8 text-white inter-500 text-xs 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Back</a>
                    </div>
                    <form className='w-full lg:w-4/5'>

                        <div className='flex justify-between flex-wrap'>
                            <div className='form-field w-full md:w-[30%] mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>First Name 
                                    <span className='relative group inline-block ml-1 align-middle'>
                                        <span className='text-[#f00] cursor-pointer'>*</span>
                                        {/* Tooltip */}
                                        <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                            Enter the admin's first name. This will be used for identification and communication purposes.
                                            <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                        </div>
                                    </span>
                                </label>
                                <input type='text' name="first_name" value={user.first_name} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                            <div className='form-field w-full md:w-[30%] mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Middle Name</label>
                                <input type='text' name="middle_name" value={user.middle_name} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                            <div className='form-field w-full md:w-[30%] mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Last Name</label>
                                <input type='text' name="last_name" value={user.last_name} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                        </div>
                        <div className='w-full md:w-4/5'>
                            <div className='flex justify-between flex-wrap'>
                                <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Email 
                                        <span className='relative group inline-block ml-1 align-middle'>
                                            <span className='text-[#f00] cursor-pointer'>*</span>
                                            {/* Tooltip */}
                                            <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                                Used for login and notifications
                                                <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                            </div>
                                        </span>
                                    </label>
                                    <input type='email' name="email" value={user.email} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                </div>
                                <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Password 
                                        <span className='relative group inline-block ml-1 align-middle'>
                                            <span className='text-[#f00] cursor-pointer'>*</span>
                                            {/* Tooltip */}
                                            <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                                Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a numeral, and a special character.
                                                <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                            </div>
                                        </span>
                                    </label>
                                    <div className='relative'>
                                        {edit ? (
                                            <input type={showPassword ? 'text' : 'password'} name="password" value={user.password} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required disabled />

                                        ) : (
                                            <>
                                                <input type={showPassword ? 'text' : 'password'} name="password" value={user.password} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                                <button onClick={() => handleShowPassword()} type='button' className='absolute right-4 top-0 h-full w-5 flex items-center justify-center'>
                                                    <img className={showPassword ? 'pass-view-btn' : 'pass-hide-btn opacity-50'} src={showPassword ? '../images/pass-view.webp' : '../images/pass-hide.webp'} alt='password hide' />
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='flex justify-between flex-wrap'>
                                <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Country
                                        <span className='relative group inline-block ml-1 align-middle'>
                                            <span className='text-[#f00] cursor-pointer'>*</span>
                                            {/* Tooltip */}
                                            <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                                Select the country where the user is located or operates from
                                                <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                            </div>
                                        </span>
                                    </label>
                                    <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                        options={countries}
                                        value={countries.find(option => option.value === user.country)}
                                        onChange={(values) => handleCountryValueChange("country", values.value)}
                                    />
                                </div>
                                <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Phone 
                                        <span className='relative group inline-block ml-1 align-middle'>
                                            {/* <span className='text-[#f00] cursor-pointer'>*</span> */}
                                            {/* Tooltip */}
                                            <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                                This number may be used for verification and important notifications.
                                                <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                            </div>
                                        </span>
                                    </label>
                                    <div className='relative'>
                                        <input type='number' name="phone_no" value={user.phone_no} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 pr-6 pl-16  2xl:pr-10 transition duration-300' required />
                                        <div className='absolute left-0 top-0 w-14'>
                                            <input type='text' name="country_code" value={countryCode[user.country]} onChange={handleValueChange} placeholder='' className='inter-400 bg-transparent text-black text-base border-r border-[#bbb] focus:border-[#B44D71] text-center h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-2 transition duration-300 inline-block' required disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className=''>
                                <div className='form-field w-full mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>State 
                                        <span className='relative group inline-block ml-1 align-middle'>
                                            <span className='text-[#f00] cursor-pointer'>*</span>
                                            {/* Tooltip */}
                                            <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                                Enter the state where admin is located.
                                                <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                            </div>
                                        </span>
                                    </label>
                                    <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                        options={states}
                                        value={states.find(option => option.value === user.state)}
                                        onChange={(values) => handleCountryValueChange("state", values.value)}
                                    />
                                </div>
                                <div className='form-field w-full mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>City <span className='text-[#f00]'>*</span></label>
                                    <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                        options={cities}
                                        value={cities.find(option => option.value === user.city)}
                                        onChange={(values) => handleCountryValueChange("city", values.value)}
                                    />
                                </div>
                                <div className='form-field w-full mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Address 01 
                                        <span className='relative group inline-block ml-1 align-middle'>
                                            <span className='text-[#f00] cursor-pointer'>*</span>
                                            {/* Tooltip */}
                                            <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                                Enter the admin's full address.
                                                <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                            </div>
                                        </span>
                                    </label>
                                    <input type='text' name="addr_line1" value={user.addr_line1} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                </div>
                                <div className='form-field w-full mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Address 02 </label>
                                    <input type='text' name="addr_line2" value={user.addr_line2} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                </div>
                                <div className='form-field w-full mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Zip Code 
                                        <span className='relative group inline-block ml-1 align-middle'>
                                            <span className='text-[#f00] cursor-pointer'>*</span>
                                            {/* Tooltip */}
                                            <div className='max-w-[300px] absolute left-1/2 -translate-x-1/2 bottom-full mb-1 bg-black text-white text-[10px] leading-[14px] text-center w-max px-2 py-1 rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity z-10'>
                                                Enter the zip code where admin is located.
                                                <div className='absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-black'></div>
                                            </div>
                                        </span>
                                    </label>
                                    <input type='number' name="zip_code" value={user.zip_code} onChange={handleValueChange} placeholder='' className='inter-400 bg-[#EFEFEF] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                </div>
                            </div>
                            <div className='flex flex-wrap'>
                                <div className='customer-radio-sngl w-full md:w-max mr-5 md:mr-8 mb-5 md:mb-8'>
                                    <input type="radio" id="suspended" name="status" onChange={handleValueChange} value='SUSPENDED' checked={user.status === "SUSPENDED"} />
                                    <label htmlFor="suspended">Suspended</label>
                                </div>
                                <div className='customer-radio-sngl w-full md:w-max mr-5 md:mr-8 mb-5 md:mb-8'>
                                    <input type="radio" id="active" name="status" onChange={handleValueChange} value='ACTIVE' checked={user.status === "ACTIVE"} />
                                    <label htmlFor="active">Active</label>
                                </div>
                                <div className='customer-radio-sngl w-full md:w-max mr-5 md:mr-8 mb-5 md:mb-8'>
                                    <input type="radio" id="cancelled" name="status" onChange={handleValueChange} value='CANCELLED' checked={user.status === "CANCELLED"} />
                                    <label htmlFor="cancelled">Cancelled</label>
                                </div>
                            </div>
                        </div>
                        <div className='flex text-center items-center mt-6 2xl:mt-10'>
                            {edit ? (
                                <button onClick={() => updateAdmin()} type="button" className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>+ Update Changes</button>

                            ) : (
                                <button onClick={() => addAdmin()} type="button" className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>+ Add Admin</button>
                            )}
                        </div>
                    </form>

                </div>
            )}
        </div>
    );
}